import React from 'react';
import CONFIG from '../../../../config';
import { ViewAllFAQButton, ViewAllFAQContainer } from './ViewAllFAQButtonStyle';

interface IButtonProps {
  content: string;
  redirect: string;
  handleClick: () => void;
}

export const ViewAllFAQButtonContainer = ({ content, redirect, handleClick }: IButtonProps) => {
  function onClickAction(){
    handleClick();
    if (CONFIG.isUPC) {
      window.location.href = redirect;
    } else {
      let win = window.open(redirect, '_blank');
      win.focus();
    }
  }

  return (
    <ViewAllFAQContainer
      beforeContent={content}
      onClick={() => onClickAction()}>
          <ViewAllFAQButton>{content}</ViewAllFAQButton>
    </ViewAllFAQContainer>

  );
};

